<div class="m-dialog"
     ref="baseWindow">
    <slot name="trigger" />
    <portal v-if="portalCreated"
            :target-el="portalTargetSelector">
        <transition name="m--is">
            <div v-if="portalMounted"
                 v-show="propOpen"
                 class="m-dialog__wrap"
                 :class="[{ 'm--is-disabled': disabled }, className ]"
                 ref="modalWrap">
                <article class="m-dialog__article"
                         ref="article"
                         role="dialog"
                         aria-modal="true"
                         :aria-labelledby="titleId"
                         :aria-describedby="messageId"
                         :class="{
                             'm--has-width-large': hasWidthLarge,
                             'm--is-message-style-large-and-center': isMessageStyleLargeAndCenter
                         }"
                         tabindex="-1">
                    <header v-if="title"
                            class="m-dialog__header">
                        <h2 :id="titleId">{{ title }}</h2>
                    </header>
                    <div :id="messageId" class="m-dialog__body">
                        <div class="m-dialog__state-icon"
                             v-if="state !== 'default'">
                            <m-message class="m-dialog__state-icon__message"
                                       :state="getState"
                                       skin="page-light"></m-message>
                        </div>
                        <div v-if="$slots.default || message"
                             class="m-dialog__message">
                            <p v-if="message"
                               v-html="message"></p>
                            <slot />
                        </div>
                        <div class="m-dialog__hint"
                             v-if="hint">
                            <div class="m-dialog__hint-body">
                                <div class="m-dialog__hint-icon">
                                    <m-icon name="m-svg__hint"
                                            size="32px"></m-icon>
                                </div>
                                <div class="m-dialog__hint-text">
                                    {{ hint }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer class="m-dialog__footer">
                        <slot name="footer"></slot>
                        <div class="m-dialog__footer__nav"
                             v-if="!$slots.footer">
                            <m-button ref="buttonOk"
                                      :style="dialogStyles"
                                      :skin="okButtonSkin"
                                      @click="onOk()">
                                {{ okLabel || $i18n.translate('m-dialog:ok') }}

                                <template v-if="okPrecision"
                                          slot="precision">{{ okPrecision }}
                                </template>
                            </m-button>
                            <m-button v-if="secBtn"
                                      :style="dialogStyles"
                                      ref="buttonSecondary"
                                      skin="secondary"
                                      @click="onSecondaryBtn()">
                                {{ secBtnLabel || $i18n.translate('m-dialog:cancel') }}
                                <template v-if="secBtnPrecision"
                                          slot="precision">{{ secBtnPrecision }}
                                </template>
                            </m-button>
                            <m-link v-if="negativeLink"
                                    @click="onCancel()"
                                    ref="link"
                                    mode="button">
                                {{ cancelLabel || $i18n.translate('m-dialog:cancel') }}
                            </m-link>
                        </div>
                    </footer>
                </article>
            </div>
        </transition>
    </portal>
</div>
